import React from 'react'
import styles from './About.module.css'

function About() {
    return (
        <div className={styles.component}>
            <h1>Disclaimer</h1>
            <p>This website is not associated with the governement of India in any way. The soul purpose of this website is to give people a platform to find available resources updated by other people.<br/><br/> The developers are not responsible for any kind of data that is put up here, as we are aware that these are tough times and the rate at which the resources are depleting is very high.</p>
        </div>
    )
}

export default About
